import {Company} from '@extensions/company'
import {Project} from '@extensions/project'
import {Hub} from 'yougile-model'
import {Time} from 'yougile-util'

type Props = {
  title?: string
  projectsCache: Record<string, Hub>
  createdProjectNames: string[]
}

export const getOrCreateProject = (
  props: Props,
  emptyProjectTitle = `Import ${Time.formatDateTime(Time.now())}`
): Hub => {
  const {projectsCache, createdProjectNames} = props

  const title = props.title || emptyProjectTitle
  if (projectsCache[title]) {
    return projectsCache[title]
  }

  const company = Company.getCurrent()
  const companyId = company.id

  if (props.title) {
    const projects = Project.listProjects(companyId, 'not-archive', true)
    const foundProject = projects.find(project => project.title === title)
    if (foundProject) {
      projectsCache[title] = foundProject
      return foundProject
    }
  }

  const project = Project.createNew(companyId, title, false, true)
  createdProjectNames.push(title)
  projectsCache[title] = project
  return project
}
